import { Outlet } from "react-router";
import TitleUpdater from "@core/components/titleUpdater/TitleUpdater";
import SimpleHeader from "@core/layouts/header/SimpleHeader";
import Footer from "@core/layouts/footer/Footer";
import { Toaster } from "@core/components/ui/Sonner";
import { cn } from "@core/utils";

export default function SimpleLayout({ usePadding = true }: { usePadding?: boolean }) {
  return (
    <>
      <TitleUpdater />
      <SimpleHeader />
      {usePadding ? (
        <div className={cn("padding-side mx-auto mt-5 lg:mt-20 lg:max-w-265")}>
          <Outlet />
        </div>
      ) : (
        <Outlet />
      )}
      <Footer />
      <Toaster />
    </>
  );
}
